import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logoDark from "../assets/images/SilverLogo_SVG.svg";
import logo from "../assets/images/SilverLogo_SVG_W.svg";

export default function NavbarNew({ navClass, navLight }) {
  let [isOpen, setMenu] = useState(false); // Set initial state to false to start with the menu closed
  let [scroll, setScroll] = useState(false);
  let [search, setSearch] = useState(false);
  let [cartitem, setCartitem] = useState(false);
  let [manu, setManu] = useState("");
  let location = useLocation();

  useEffect(() => {
    let current = location.pathname.substring(location.pathname.lastIndexOf("/") + 1);
    setManu(current);
  }, [location.pathname]);

  useEffect(() => {
    function scrollHandler() {
      setScroll(window.scrollY > 50);
    }
    window.addEventListener("scroll", scrollHandler);

    let searchModal = () => {
      setSearch(false);
    };
    document.addEventListener("mousedown", searchModal);

    let cartModal = () => {
      setCartitem(false);
    };
    document.addEventListener("mousedown", cartModal);
    window.scrollTo(0, 0);

    return () => {
      window.removeEventListener("scroll", scrollHandler);
      document.removeEventListener("mousedown", searchModal);
      document.removeEventListener("mousedown", cartModal);
    };
  }, []);

  const toggleMenu = () => {
    setMenu(!isOpen);
  };

  return (
    <header id="topnav" className={`${scroll ? "nav-sticky" : ""} ${navClass}`}>
      <div className="container">
        {navLight === true ? (
          <Link className="logo" to="/jobs">
            <span className="logo-light-mode" style={{ minWidth: "70px" }}>
              <img src={logoDark} className="l-dark p-1" alt="logo" />
              <img src={logo} className="l-light" alt="logo" />
            </span>
            <img src={logo} className="logo-dark-mode" alt="logo" />
          </Link>
        ) : (
          <Link className="logo" to="/jobs">
            <span className="logo-light-mode">
              <img src={scroll ? logoDark : logo} className="l-dark p-1" alt="logo" />
              <img src={logo} className="l-light" alt="logo" />
            </span>
            <img src={logo} className="logo-dark-mode" alt="logo" />
          </Link>
        )}
        <div className="menu-extras">
          <div className="menu-item">
            <i to="#" className="navbar-toggle" id="isToggle" onClick={toggleMenu}>
              <div className="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </i>
          </div>
        </div>

        <div id="navigation" className={`navbar-collapse ${isOpen ? "show" : ""}`}>
          <ul className="navigation-menu nav-right nav-light">
            <li className={`${["1", "2", "3", "jobs"].includes(manu) ? "active" : ""} has-submenu parent-menu-item`}>
              <Link to="/jobs">Jobs</Link>
            </li>
            <li className={manu === "aboutus" ? "active" : ""}>
              <Link to="/aboutus" className="sub-menu-item">
                About Us
              </Link>
            </li>
            <li className={manu === "contactus" ? "active" : ""}>
              <Link to="/contactus" className="sub-menu-item">
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}
